import {createSelector} from 'reselect';
import {durationBetween, roundDecimal} from '../../../../../common/redux/selectors/util';
import DespatchMonitoringResponsePerformanceColumns
  from '../../containers/DespatchMonitoringResponsePerformanceColumns';
import ReportsDefinition from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting.DESPATCH_MONITORING_RESPONSE_PERFORMANCE.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting.DESPATCH_MONITORING_RESPONSE_PERFORMANCE.isLoading;

export const getData = ReportsDefinition.DESPATCH_MONITORING_RESPONSE_PERFORMANCE.getDataFunction();

function calculateRatioResponded(responsePerformanceAggregateRecord) {
  return roundDecimal((responsePerformanceAggregateRecord.receptaclesResponded /
    responsePerformanceAggregateRecord.receptaclesPreadvised) * 100);
}

function calculateResdesLastFirstDuration(responsePerformanceAggregateRecord) {
  return durationBetween(
    responsePerformanceAggregateRecord.resdesFirstScan,
    responsePerformanceAggregateRecord.resdesLastScan,
  );
}

function mapReponsePerfomanceData(responsePerformanceData) {
  const {
    responsePerformanceAggregateRecord,
    responsePerformanceRecord,
  } = responsePerformanceData;
  const { despatchId } = responsePerformanceRecord;
  return {
    ...responsePerformanceData,
    responsePerformanceAggregateRecord: {
      ...responsePerformanceAggregateRecord,
      ratioResponded: calculateRatioResponded(responsePerformanceAggregateRecord),
      resdesLastFirstDuration: calculateResdesLastFirstDuration(responsePerformanceAggregateRecord),
    },
    ratioResponded: calculateRatioResponded(responsePerformanceAggregateRecord),
    id: despatchId,
  };
}

export const getCalculatedData = createSelector([getData], data => data.map(mapReponsePerfomanceData));

export const getColumns = createSelector(getCalculatedData, DespatchMonitoringResponsePerformanceColumns);
